export const moreAppsLinkText = "WDYnvb";
export const openInNewTab = "Ub6gI";
export const openInNewWindow = "xVtusd";
export const unpinApp = "DC$pgb";
export const pinApp = "mGC6nd";
export const uninstallApp = "BgFa$c";
export default {moreAppsLinkText,openInNewTab,openInNewWindow,unpinApp,pinApp,uninstallApp};